import { render, staticRenderFns } from "./trainingHead.vue?vue&type=template&id=1057c1dc&scoped=true&"
import script from "./trainingHead.vue?vue&type=script&lang=js&"
export * from "./trainingHead.vue?vue&type=script&lang=js&"
import style0 from "./trainingHead.vue?vue&type=style&index=0&id=1057c1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1057c1dc",
  null
  
)

export default component.exports